import SelfInitComponent from "General/global-js/SelfInitComponent";
import nextTick from "General/global-js/nextTick";
import "jquery-match-height";
import "slick-carousel";

class ContentTeaserBlockComponent extends SelfInitComponent {

    constructor(selector) {

        super(selector);
        this.sliderIsInitializes = false;
    }

    init() {
        var that = this;

        if (this.isMobileWidth()) {
            this.initSlider();
        }

        that.checkTextBoxHeight();


        $(window).on("resize", function () {
            if (that.isMobileWidth() && !that.sliderIsInitializes) {
                that.initSlider();
            }

            setTimeout(function () {
                that.checkTextBoxHeight();
            }, 100);     
        });
    }

    isMobileWidth() {
        return $(window).width() <= 767;
    }

    initSlider() {
        this.sliderIsInitializes = true;

        $(".content-teaser-block").each(function () {
            var $dotsNavContainer = $(this).find(".pagination-dots");
            var $prevArrow = $(this).find(".pagination .pagination-prev");
            var $nextArrow = $(this).find(".pagination .pagination-next");
            var $slider = $(this).find(".content-teaser-block-slider");
            var dotsForTranslation = $dotsNavContainer.attr("data-dots-of-translation");

            // hack for fixing labels that always gets overriden
            var fixDotTranslation = function () {
                if (!dotsForTranslation?.length) {
                    return;
                }

                nextTick(function () {
                    var slideCounter = 1;
                    var slideCount = $dotsNavContainer.find("button").length;
                    $dotsNavContainer.find("button").each(function () {
                        var ariaLabel = slideCounter + " " + dotsForTranslation + " " + slideCount;
                        $(this).attr("aria-label", ariaLabel);
                        slideCounter++;
                    });
                });
            };

            $slider.on("init reInit afterChange", function (slick) {
                fixDotTranslation();
            });

            $slider.not('.slick-initialized').slick({
                speed: 0,
                adaptiveHeight: true,
                arrows: true,
                dots: true,
                appendDots: $dotsNavContainer,
                prevArrow: $prevArrow,
                nextArrow: $nextArrow,
                dotsClass: "pagination-dots",
            });
        });
    }

    checkTextBoxHeight() {
        var textboxes = $(".content-teaser-block-page .text-box");
        var headlines = $(".content-teaser-block-page .headline-element")
        var blockText = $(".content-teaser-block-page .content-teaser-block-text")
        var links = $(".content-teaser-block-page .link")      

        if (!this.isMobileWidth()) {
            delete headlines.first();
            delete blockText.first();
            delete links.first();
            delete textboxes.first();
        }

        headlines.matchHeight();
        blockText.matchHeight();
        links.matchHeight();
        textboxes.matchHeight();
    }
}

new ContentTeaserBlockComponent(".content-teaser-block-slider");